import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import LazyLoadImage from 'components/LazyLoad/Image';

import styles from './styles.module.scss';

const Container = ({
	children,
	className,
	innerClassName,
	blockTag,
	morphing,
	imageSrc,
	width,
	...props
}) => {
	const ContainerTag = blockTag || 'div';
	const containerCx = cx(styles.container, className, styles[`width_${width}`]);
	const containerInnerCx = cx(
		styles.inner,
		styles[`morphing_${morphing}`],
		innerClassName
	);

	return imageSrc ? (
		<LazyLoadImage className={containerCx} imageSrc={imageSrc}>
			<ContainerTag {...props}>
				<div className={containerInnerCx}>{children}</div>
			</ContainerTag>
		</LazyLoadImage>
	) : (
		<ContainerTag className={containerCx} {...props}>
			<div className={containerInnerCx}>{children}</div>
		</ContainerTag>
	);
};

Container.propTypes = {
	children: PropTypes.node.isRequired,
	width: PropTypes.oneOf(['narrow']),
	className: PropTypes.string,
	innerClassName: PropTypes.string,
	blockTag: PropTypes.string,
	morphing: PropTypes.string,
	imageSrc: PropTypes.string
};

export default Container;
